import { QueryClientProvider } from '@tanstack/react-query';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useRoutes } from 'react-router';
import { createQueryClient } from 'src/lib/query';
import { routes } from 'src/routes';
import './App.scss';

export const App: FunctionComponent = () => {
  const [queryClient] = useState(createQueryClient);

  return <QueryClientProvider client={queryClient}>{useRoutes(routes)}</QueryClientProvider>;
};
